// FRESH® shared scripts
(function(){
  const nav=document.getElementById('nav');
  const hero=document.querySelector('.sub-hero,.hero');
  function onScroll(){
    if(!nav)return;
    var scrolled = window.scrollY > 40;
    nav.classList.toggle('scrolled', scrolled);
    if(hero){
      // Header is "light" (transparent, cream text) ONLY while it floats over the dark
      // scrim band at the very top of the hero. As soon as the page scrolls (past ~40px),
      // the header becomes the solid cream 'scrolled' bar — so light text never sits over
      // the bright middle of a photo hero. Light state requires: over hero AND not scrolled.
      var overHero = window.scrollY < hero.offsetHeight - 90;
      nav.classList.toggle('light', overHero && !scrolled);
    } else {
      nav.classList.remove('light');
    }
  }
  window.addEventListener('scroll',onScroll); onScroll();

  // reveal on scroll — robust against very tall elements (e.g. full article bodies)
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  function showEl(el){ el.classList.add('in'); }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ showEl(e.target); io.unobserve(e.target); } });
    },{threshold:0, rootMargin:'0px 0px -8% 0px'});
    revealEls.forEach(function(el,i){ el.style.transitionDelay=(i%4*70)+'ms'; io.observe(el); });
    // Reveal anything already in/above the viewport on first paint
    requestAnimationFrame(function(){
      revealEls.forEach(function(el){
        var r=el.getBoundingClientRect();
        if(r.top < (window.innerHeight||document.documentElement.clientHeight)){ showEl(el); io.unobserve(el); }
      });
    });
    // Failsafe: never let content stay hidden — reveal all after 1.2s regardless
    setTimeout(function(){ revealEls.forEach(showEl); }, 1200);
  } else {
    revealEls.forEach(showEl);
  }

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(function(btn){
    btn.addEventListener('click',function(){
      const item=btn.closest('.faq-item');
      const ans=item.querySelector('.faq-a');
      const open=item.classList.contains('open');
      item.classList.toggle('open');
      ans.style.maxHeight=open?null:ans.scrollHeight+'px';
    });
  });

})();

// Respect prefers-reduced-motion: instantly reveal, skip transitions
(function(){
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('in');el.style.transition='none';});
  }
})();
